<template>
  <v-row justify='center'>
    <v-dialog
      v-model='showLogoutModal'
      persistent
      max-width='500'
    >
      <v-card>
        <v-card-title class='headline'>
          Sair
        </v-card-title>
        <v-card-text>Tem certeza que deseja sair do Ambia?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click='logout()'
          >
            Sair
          </v-btn>
          <v-btn
            color='primary'
            @click='cancel()'
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: 'LogoutModal',
  data () {
    return {
      showLogoutModal: false
    }
  },
  methods: {
    logout () {
      localStorage.clear()
      this.$auth.signOut().then(() => {
        this.$router.replace('/login')
      })
    },
    open () {
      this.showLogoutModal = true
    },
    cancel () {
      this.showLogoutModal = false
    }
  },
}
</script>
